export const brandPalette = {
  "Original Primary": {
    id: "color",
    value: "#2661ab",
  },
  "Original Medium": {
    id: "color",
    value: "#99cbeb",
  },
  "Original Large": {
    id: "color",
    value: "#1b2e51",
  },
  "Rich Yolk Primary": {
    id: "color",
    value: "#eb7806",
  },
  "Rich Yolk Secondary": {
    id: "color",
    value: "#fcc501",
  },
  "Super Eggs Primary": {
    id: "color",
    value: "#006d69",
  },
  "Super Eggs Secondary": {
    id: "color",
    value: "#d1e0d7",
  },
  "Super Eggs Secondary Dark": {
    id: "color",
    value: "#045b54",
  },
  "Super Eggs Secondary Accent": {
    id: "color",
    value: "#e9551d",
  },
  "Rich Yolk Opulent Hot Foil": {
    id: "color",
    value: "#e5ab4a",
  },
  "Rich Yolk Opulent Primary": {
    id: "color",
    value: "#202020",
  },
  "Rich Yolk Opulent Secondary": {
    id: "color",
    value: "#000000",
  },
  "Grand Primary": {
    id: "color",
    value: "#848886",
  },
  White: {
    id: "color",
    value: "#ffffff",
  },
  "Dabbling Duck Primary": {
    id: "color",
    value: "#8a75d0",
  },

  "Dabbling Duck Secondary": {
    id: "color",
    value: "#ad95db",
  },
  Duck: {
    id: "color",
    value: "#8a75d0",
  },
  "Duck Egg": {
    id: "color",
    value: "#ad95db",
  },
  "Quirky Quail Primary": {
    id: "color",
    value: "#3b2516",
  },
  "Quirky Quail Secondary": {
    id: "color",
    value: "#fcedde",
  },
  "Opulent Blue": {
    id: "color",
    value: "#00263e",
  },
  "Grand Yolk": {
    id: "color",
    value: "#ff8b3a",
  },
  "Grand ": {
    id: "color",
    value: "#ffae60",
  },
  "Yolk ": {
    id: "color",
    value: "#ff6b0f",
  },
  "Yolk Yellow": {
    id: "color",
    value: "#fdb71a",
  },
  "Whisked ": {
    id: "color",
    value: "#004761",
  },
  "Albumen ": {
    id: "color",
    value: "#f3f8ea",
  },
  "Whole ": {
    id: "color",
    value: "#ffc709",
  },
  "Whole White": {
    id: "color",
    value: "#f8de8d",
  },
  "Whole Yolk": {
    id: "color",
    value: "#ffa400",
  },
}

export const brandSpacing = {
  "MS-6": {
    id: 0,
    value: 0,
  },
  "MS-5": {
    id: 1,
    value: 5,
  },
  "MS-4": {
    id: 2,
    value: 6,
  },
  "MS-3": {
    id: 3,
    value: 9,
  },
  "MS-1": {
    id: 4,
    value: 10,
  },
  "MS-2": {
    id: 5,
    value: 14,
  },
  MS0: {
    id: 6,
    value: 16,
  },
  MS1: {
    id: 7,
    value: 23,
  },
  MS2: {
    id: 8,
    value: 26,
  },
  MS3: {
    id: 9,
    value: 37,
  },
  MS4: {
    id: 10,
    value: 42,
  },
  MS5: {
    id: 11,
    value: 59,
  },
  MS6: {
    id: 12,
    value: 68,
  },
  MS7: {
    id: 13,
    value: 96,
  },
  MS8: {
    id: 14,
    value: 110,
  },
  MS9: {
    id: 15,
    value: 155,
  },
  MS10: {
    id: 16,
    value: 187,
  },
}
